// reducers.ts
import { PlanState } from '../../types/client';
import { PlanActionTypes, SET_ERROR, SET_PLAN } from './planTypes';

const initialState: PlanState = {
    plan: {
        cancelled: false,
        isActive: false,
        reactivated: false,
    },
    error: '',
};

export function planReducer(state: PlanState = initialState, action: PlanActionTypes): PlanState {
    switch (action.type) {
        case SET_PLAN:
            return {
                ...state,
                plan: action.payload,
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
